import emailjs from '@emailjs/browser';

// EmailJS Configuration
// You'll need to replace these with your actual EmailJS credentials
// Get these from your EmailJS dashboard at https://dashboard.emailjs.com

export const EMAILJS_CONFIG = {
  // Your EmailJS Service ID (found in EmailJS dashboard > Integration > API Keys)
  SERVICE_ID: 'service_7sd7fdj',
  
  // Your EmailJS Template ID (found in EmailJS dashboard > Email Templates)
  TEMPLATE_ID: 'template_ieg4qlk',
  
  // Your EmailJS Public Key (found in EmailJS dashboard > Integration > API Keys)
  PUBLIC_KEY: 'UO14IddEzhd_XKCNd',
  
  // Email recipient — must also match the To field in the EmailJS template
  TO_EMAIL: 'chris@matthieu.us'
};

export const CONTACT_EMAIL = EMAILJS_CONFIG.TO_EMAIL;
export const CONTACT_PHONE = '480-381-3574';
export const CONTACT_PHONE_TEL = '+14803813574';

// Initialize EmailJS
export const initializeEmailJS = () => {
  emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
};
